import DocumentIssuerMode from "../../entities/DocumentIssuerMode";

/**
 * Identity printed on the documents the agency hands to clients and recipients (invoices,
 * delivery sheets, labels). The documents themselves are rendered by the API, so this only
 * configures what it prints.
 */
export default class AgencyDocumentSettings {
    constructor(
        public mode: DocumentIssuerMode = DocumentIssuerMode.AGENCY,
        public name?: string,
        public phone?: string,
        public address?: string,
        public email?: string,
        public logo?: string,
        public footerNote?: string,
    ) {
    }
}
